export const getConfigurationKey = (facetKey: string, lookup: Map<string, string>): string | undefined =>
  lookup.get(facetKey) ||
  lookup.get(facetKey.split('.').slice(-2).join('.')) ||
  lookup.get(facetKey.split('.').pop() ?? '');
